import { CalendarDateTemplateEvent, Calendar } from "primereact/calendar";
import { ContentProps, Dialog } from "primereact/dialog";
import { DailyEntryViewModel } from "../../../ViewModel";
import { Icons } from "./Icons/Icons";
import { useNavigate } from "react-router";
import { addLocale } from 'primereact/api';




// Define your custom locale with 3-character day names
addLocale('custom', {
    firstDayOfWeek: 0, // Monday as the first day of the week
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // 3-character abbreviations
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // 3-character abbreviations
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear'
});


export function GLCalendar({ show, onHideCallback }: { show: boolean, onHideCallback: () => void }) {

    const navigate = useNavigate();


    const dateList = DailyEntryViewModel.DateList;
    const dateTemplate = (event: CalendarDateTemplateEvent) => {

        var date = new Date(event.year, event.month, event.day);
        if (dateList.indexOf(date.toISOString()) >= 0)
            return (
                <p className="gl-today-info-typography" >{event.day}</p>
            );
        else {
            return (
                <p className="gl-today-date-typography">{event.day}</p>
            );
        }
    }


    const dialogContent: React.ReactNode | ((props: ContentProps) => React.ReactNode) =
        ({ hide }) => (
            <>
                <button
                    className='gl-close-button'
                    onClick={(e) => {
                        hide(e);
                        onHideCallback && onHideCallback();
                    }}>
                    <Icons.CloseIcon />
                </button>
                <div className=''>
                    <Icons.TitleIcon />
                    <p>Select a journal entry</p>
                </div>
                <Calendar
                    inline
                    selectionMode="single"
                    touchUI
                    onChange={
                        async (e) => {
                            const date = e.value as Date;
                            const route = await DailyEntryViewModel.GetRoute(date);
                            onHideCallback && onHideCallback();
                            navigate(route);
                        }
                    }
                    onHide={() => {
                        onHideCallback && onHideCallback();
                    }}
                    dateTemplate={dateTemplate}
                    // headerTemplate={headerTemplate}
                    className="gl-calendar"
                    locale="custom"
                    pt={{
                        title: {
                            className: 'gl-content-header-typography'
                        },
                        header: {
                            className: 'gl-content-header-typography'
                        },
                        tableHeader: {
                            className: 'gl-content-header-typography text-center'
                        }

                    }}
                />
            </>
        );


    return (
        <Dialog
            className="gl-popup gl-calendar"
            visible={show}
            dismissableMask
            resizable={false}
            maskClassName='gl-quote-mask'
            onHide={() => (onHideCallback && onHideCallback())}
            content={dialogContent}
        />
    )
}